<template>
	<div class="am-hero"
		:class="{ 'is-idle': !init || !loaded }"
	>
		<div class="am-hero__background" :data-src="background">
		</div>

		<div class="am-hero__container">
			<div class="am-hero__wrapper">
				<header class="am-hero__header">
					<am-text class="am-hero__title am-hero__title--first" type="title">
						<span>
							{{ titles[0] }}
						</span>
					</am-text>
					<am-text class="am-hero__title am-hero__title--second" type="title">
						<span>
							{{ titles[1] }}
						</span>
					</am-text>
					<am-text class="am-hero__title am-hero__title--third" type="title">
						<span>
							{{ titles[2] }}
						</span>
					</am-text>
				</header>

				<am-text class="am-hero__text" type="body">
					{{ text }}
				</am-text>
			</div>

			<div class="am-hero__image" :data-src="image">
			</div>
		</div>
	</div>
</template>
A
<script>
import AMText from '@/components/atoms/AMText'
import { TweenMax, Power2 } from 'gsap/TweenMax'

export default {
	components: {
		'am-text': AMText,
	},

	props: {
		init: {
			type: Boolean,
			default: true
		},
		titles: {
			type: Array,
			default: () => ([
				'Lorem.',
				'Ipsum.',
				'Rules'
			])
		},
		text: {
			type: String,
			default: 'Adipisicing quo delectus deleniti aut quis, quasi totam? Vero adipisci nostrum itaque ducimus culpa?'
		},
		background: {
			type: String,
			default: 'https://placeimg.com/640/480/nature/grayscale'
		},
		image: {
			type: String,
			default: 'https://placeimg.com/640/480/nature'
		}
	},
	
	data: () => ({
		loaded: false
	}),

	watch: {
		init(value) {
			if (value)
				this.onLoad()
		}
	},

	mounted() {
		if (this.init)
			this.onLoad()
	},

	methods: {
		start() {
			// Background
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-hero__background'), 1.5, {
				y: '-200px',
				opacity: 0,
				ease: Power2.easeOutl
			})

			// Gallery
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-hero__image'), 2, {
				x: '30%',
				opacity: 0,
				ease: Power2.easeOut
			})

			// Titles
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-hero__title span'), 1.5, {
				delay: .2,
				y: '200px',
				ease: Power2.easeOut
			}, .2)
		},

		onLoad() {
			let images = this.$el.querySelectorAll('.am-hero__image, .am-hero__background')

			images.forEach((image, index) => {
				let img = new Image()

				img.src = image.dataset.src
				img.onload = () => {
					image.style.backgroundImage = `url(${img.src})`

					if (index + 1 == images.length) {
						this.loaded = true
						this.start()
					}
				}
			})
		}
	}
}
</script>

<style lang="scss">
.am-hero{
	background: white;
	position: relative;
	z-index: 10;
	transition: .3s $easeInOutQuad;
	&__container{
		display: flex;
		flex-flow: column;
		height: 100%;
		@include outer-container;
	}
	&__wrapper{
		flex: 1;
		@include grid-column(6);
	}
	&__background{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100px;
		opacity: 1;
		z-index: -1;
		background-size: cover;
		background-position: center;
	}
	&__header{
		margin-top: 54px;
		margin-bottom: 32px;
		padding-bottom: 24px;
		position: relative;
		&:after{
			content: "";
			position: absolute;
			width: 100%;
			height: 1px;
			bottom: -1px;
			background: rgba($c-gray, .6);
			transition: 1s $easeInOutQuad .75s;
		}
	}
	&__title{
		line-height: 56px;
		overflow: hidden;
		span{
			display: block;
		}
		&--first{
			color: white;
		}
		&--second{
			color: #E3E3E3;
		}
		&--third{
		}
	}
	&__text{
		opacity: .8;
		margin-bottom: 40px;
		transition: 1s $easeOutQuad 1.5s;
	}
	&__image{
		flex: 1;
		background-size: cover;
		background-position: center;
	}

	&.is-idle{
		opacity: 0;
		.am-hero{
			&__header{
				&:after{
					width: 0%;
					opacity: 0;
					transition: .5s $easeInOutQuad;
				}
			}
			&__text{
				transform: translateY(20px);
				opacity: 0;
				transition: .5s $easeInOutQuad;
			}
		}
	}

	@include grid-media($tablet-grid) {
		&__wrapper{
			@include grid-column(4);
		}
	}

	@include grid-media($desktop-grid) {
		display: block;
		&__image{
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 50%;
			&:after{
				content: "";
				display: block;
				padding-top: 60%;
			}
		}
		&__background{
			height: 200px;
		}
		&__header{
			margin-top: 144px;
			&:after{
				width: 280px;
			}
		}
		&__title{
			line-height: 64px;
		}
		&__wrapper{
			@include grid-column(5);
		}
	}
}
</style>
